import axios from '@/plugins/axios';

export function findSysInvoiceList(params) {
  return axios.post('/invoice/findSysInvoiceList', params);
}

export function saveInvoice(params) {
  return axios.post('/invoice/saveInvoice', params);
}

export function findInvoiceById(invoiceId) {
  return axios.get('/invoice/findInvoiceById', {
    params: {
      invoiceId: invoiceId
    }
  });
}

export function updateInvoiceStatus(params) {
  return axios.post('/invoice/updateInvoiceStatus', params);
}
